export enum SubChapterType {
  VideoAndContentAndCode = "VIDEO_AND_CONTENT_AND_CODE",
  VideoAndContentAndTestCode = "VIDEO_AND_CONTENT_AND_TESTCODE",
  ContentAndCode = "CONTENT_AND_CODE",
  ContentAndTestCode = "CONTENT_AND_TESTCODE",
  Content = "CONTENT",
  Video = "VIDEO",
  Test = "TEST",
  Survey = "SURVEY",
  /**
   * 외부 LMS(인프런 등)에서 학습되는 sub_chapter.
   * 학습 UI 대신 "인프런에서 학습하기" 버튼만 노출. 진도율은 백엔드 sync로 갱신.
   */
  ExternalInflearn = "EXTERNAL_INFLEARN"
}
